import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { CloseFilledOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { getPaymentMethodLabel } from "../../../../utils/paymentMethodLabels"

import { Button } from "@/components/common/Button"
import type { CompanyPaymentTypeMethod } from "@/graphql/codegen/graphql"

interface DefaultPaymentMethodConfirmModalProps {
  onClose: () => void
  onConfirm: () => void
  newDefaultPaymentMethod: CompanyPaymentTypeMethod
  currentDefaultPaymentMethod?: CompanyPaymentTypeMethod
}

export const DefaultPaymentMethodConfirmModal: FC<DefaultPaymentMethodConfirmModalProps> = ({
  onClose,
  onConfirm,
  newDefaultPaymentMethod,
  currentDefaultPaymentMethod,
}) => {
  const newMethodLabel = getPaymentMethodLabel(newDefaultPaymentMethod.method)
  const currentMethodLabel = currentDefaultPaymentMethod
    ? getPaymentMethodLabel(currentDefaultPaymentMethod.method)
    : null

  const title = "Change Default Payment Method"
  const description = currentMethodLabel
    ? `Are you sure you want to change the default payment method from ${currentMethodLabel} to ${newMethodLabel}?`
    : `Are you sure you want to set ${newMethodLabel} as the default payment method?`

  return (
    <Dialog open onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Box display='flex' justifyContent='flex-end'>
          <Button size='small' appearance='text' onClick={onClose}>
            <CloseFilledOutlined className='text-blue-gray' />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box textAlign='center'>
          <WarningOutlined className='size-[48px] text-secondary-600' />
          <Typography variant='h5' color='primary' className='mt-6 font-normal'>
            {title}
          </Typography>
          <Typography variant='h6' className='mt-6 px-3 text-base leading-[150%] tracking-[-0.85px] text-gray-700'>
            {description}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display='flex' justifyContent='flex-end' width='100%' p={2}>
          <Button appearance='text' variant='secondary' className='mr-2' onClick={onClose}>
            Cancel
          </Button>
          <Button variant='primary' onClick={onConfirm}>
            Confirm Change
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}
